import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

$(".section4 ul li").eq(0).addClass("active");
$(".section4 .left .pic").eq(0).addClass("active");
$(".section4 ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section4 .left .pic").eq(index).addClass("active").siblings().removeClass("active");
})